var l = {};
Object.defineProperty(l, "__esModule", { value: !0 });
function c() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e.length === 2)
    return a(e[0], e[1]) || null;
  var n = e.slice(1).reduce(function(u, o) {
    return a(u, o);
  }, e[0]);
  return n || null;
}
var p = l.default = c, r = /* @__PURE__ */ new WeakMap();
function a(e, t) {
  if (e && t) {
    var n = r.get(e) || /* @__PURE__ */ new WeakMap();
    r.set(e, n);
    var u = n.get(t) || function(o) {
      s(e, o), s(t, o);
    };
    return n.set(t, u), u;
  }
  return e || t;
}
function s(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
export {
  p as _
};
//# sourceMappingURL=composeRefs-YONvD-rx.mjs.map
